import React, { useState, useEffect, useRef } from "react";
import Modal from "../Modal/Modal";
import { Link, useNavigate } from "react-router-dom";
import image from "../../../src/assets/images/logo.png";
import Notification from "../../../src/assets/images/icons/notification.svg";
import { useSelector } from "react-redux";
import { getAdminRoleLabel, getStoredAdmin } from "../../utils/adminAuth";

const Header = () => {
  const navigate = useNavigate();
  const [logout, showLogout] = useState(false);
  const [logoutModal, setLogoutModal] = useState({ value: false });
  const dropdownRef = useRef(null);

  const loginSuccess = useSelector(
    (state) => state.loginInfo.userInformation.data
  );
  const storedAdmin = getStoredAdmin();
  const admin = storedAdmin || loginSuccess?.admin || null;
  const roleLabel = getAdminRoleLabel(admin) || "Admin";

  const logOutClickHandler = (event) => {
    event.stopPropagation();
    showLogout((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        showLogout(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const logOut = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <nav className="navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
        <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
          <a className="navbar-brand brand-logo">
            <img src={image} alt="logo" />
          </a>
          <a className="navbar-brand brand-logo-mini">
            <img src={image} alt="logo" />
          </a>
        </div>
        <div className="navbar-menu-wrapper d-flex align-items-center">
          <ul className="navbar-nav navbar-nav-right">
            <li className="mr-4">
              <Link to="/notification">
                <img src={Notification} alt="Notification" />
              </Link>
            </li>
            <li
              ref={dropdownRef}
              className={`nav-item nav-profile dropdown drop-right w-auto ${
                logout ? " show" : ""
              }`}
              style={{ cursor: "pointer" }}
              onClick={logOutClickHandler}
            >
              <a className="nav-link align-items-center">
                <div className="nav-profile-text">
                  <p className="mb-0">{roleLabel}</p>
                </div>
              </a>
              {logout && (
                <div className={`dropdown-menu right-menu show`}>
                  <Link
                    to="/profile"
                    className="dropdown-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      showLogout(false);
                    }}
                  >
                    <i className="mdi mdi-account mr-2"></i> Profile
                  </Link>
                  <a
                    className="dropdown-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      showLogout(false);
                      setLogoutModal({ value: true });
                    }}
                  >
                    <i className="mdi mdi-logout mr-2"></i> Logout
                  </a>
                </div>
              )}
            </li>
          </ul>
          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            data-toggle="offcanvas"
          >
            <span className="mdi mdi-menu color-lightblue" />
          </button>
        </div>
        <Modal
          show={logoutModal.value}
          onClose={() => setLogoutModal({ value: false })}
          style={{ zIndex: "1000" }}
          className=" shadow-none"
        >
          <div className="modal-dialog modal-md modal-center" role="document">
            <div className="modal-content bg-black border-light">
              <div className="modal-body text-center my-4 py-4">
                <h4 className="text-white">
                  Do you want to
                  <br />
                  Logout?
                </h4>
                <div className="col-sm-12 mx-auto d-flex align-items-center mt-4 row">
                  <div className="col-6 px-2">
                    <a
                      type="button"
                      className="btn btn-primary	btn-lg btn-block font-16 rounded-pill"
                      onClick={logOut}
                    >
                      Yes
                    </a>
                  </div>
                  <div className="col-6 px-2">
                    <button
                      type="button"
                      className="btn btn-default btn-lg btn-block font-16 rounded-pill"
                      data-dismiss="modal"
                      onClick={() => setLogoutModal({ value: false })}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </nav>
    </>
  );
};

export default Header;
